import React from "react";
import { Box, Typography, Button } from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const maintenanceTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#ff0033" }, // Red
    background: { default: "#000000", paper: "#111111" }, // Black
    text: { primary: "#ffffff" },
  },
});

const MaintenancePage: React.FC = () => {
  return (
    <ThemeProvider theme={maintenanceTheme}>
      <Box
        sx={{
          // width: "100%",
          // maxWidth: "100%",
         height:'100vh',
          backgroundColor: "background.default",
          color: "text.primary",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          p: 3,
        }}
      >
        <BuildIcon sx={{ fontSize: 100, color: "primary.main", mb: 2 }} />

        <Typography variant="h3" sx={{ fontWeight: "bold", mb: 1 }}>
          We'll Be Back Soon
        </Typography>

        <Typography variant="h6" sx={{ maxWidth: 600, mb: 3 }}>
          Our system is currently undergoing scheduled maintenance.
          We’ll restore service as quickly as possible.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          sx={{ px: 4, py: 1.5, fontSize: "1rem" }}
          onClick={() => (window.location.href = "/")}
        >
          Retry
        </Button>
      </Box>
    </ThemeProvider>
  );
};

export default MaintenancePage;